import type { IconProps } from './types';

export const TrendIcon: React.FC<IconProps> = ({
  className,
  width = '16px',
  height = '16px',
  color = 'currentColor',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="trend-up">
      <path
        id="vector"
        d="M3.88961 12.6439C4.09789 12.8521 4.43558 12.8521 4.64385 12.6439L11.7334 5.55431L11.7334 10.1334C11.7334 10.428 11.9722 10.6667 12.2667 10.6667C12.5613 10.6667 12.8001 10.4279 12.8001 10.1334L12.8001 4.26673C12.8001 4.12528 12.7439 3.98963 12.6439 3.88961C12.5438 3.78959 12.4082 3.7334 12.2667 3.7334L6.40007 3.7334C6.10552 3.7334 5.86673 3.97218 5.86673 4.26673C5.86673 4.56129 6.10551 4.80007 6.40007 4.80007L10.9792 4.80007L3.88961 11.8896C3.68133 12.0979 3.68133 12.4356 3.88961 12.6439Z"
        fill={color}
      />
    </g>
  </svg>
);
